import { Injectable } from '@angular/core';
import en from '../../locales/en.json';
import ptBR from '../../locales/pt-BR.json';

export type LocaleCode = 'en' | 'pt-BR';

type Messages = Record<string, string>;

const LOCALES: Record<LocaleCode, Messages> = {
  en,
  'pt-BR': ptBR,
};

const STORAGE_KEY = 'castor.runner.lang';
const DEFAULT_LOCALE: LocaleCode = 'pt-BR';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private _locale: LocaleCode = this.loadInitialLocale();

  get locale(): LocaleCode {
    return this._locale;
  }

  setLocale(locale: LocaleCode): void {
    if (this._locale === locale) return;
    this._locale = locale;
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(STORAGE_KEY, locale);
      }
    } catch {
      // ignore storage errors
    }
  }

  t(key: string, params?: Record<string, string | number>): string {
    const msg = this.lookup(this._locale, key) ?? this.lookup(DEFAULT_LOCALE, key) ?? key;
    if (!params) return msg;
    return Object.keys(params).reduce((acc, k) => {
      const token = `{{${k}}}`;
      return acc.replaceAll(token, String(params[k]));
    }, msg);
  }

  private lookup(locale: LocaleCode, key: string): string | undefined {
    return LOCALES[locale]?.[key];
  }

  private loadInitialLocale(): LocaleCode {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored === 'en' || stored === 'pt-BR') return stored as LocaleCode;
        if (stored === 'pt') return 'pt-BR';
      }
    } catch {
      // ignore storage errors
    }
    return DEFAULT_LOCALE;
  }
}

